import { makeAutoObservable } from 'mobx';
import { validatePositionPriceTrail } from './validatePositionPriceTrail';

export class PositionPriceTrailData {
  amount = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.amount = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validatePositionPriceTrail(this.amount);
    return result;
  };
  returnJson = () => {
    return {
      amount: this.amount,
    };
  };

  //specific methods
  setAmount = (number) => {
    this.amount = number;
  };
}
